import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20.475 15.029a9 9 0 1 0 -7.962 5.957","key":"svg-0"}],["path",{"d":"M16 19h6","key":"svg-1"}]]

const IconCircleMinus2 = createReactComponent('outline', 'circle-minus-2', 'CircleMinus2', __iconNode);

export default IconCircleMinus2;